import styled from 'styled-components/macro';
import { COLORS } from 'utils/styles/colors';
import { FLEX_CONTAINER } from 'utils/styles/flex';
import { FONTS, FONT_FAMILY } from 'utils/styles/fonts';
import { deviceMax } from 'utils/styles/breakpoints';

export const QuestionsBlock = styled.div`
  width: 100%;
  padding-right: 10px;
  margin-bottom: 50px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px ${COLORS.darkGray};
    background: ${COLORS.lightGray};
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${COLORS.black};
    border-radius: 10px;
  }

  @media only screen and ${deviceMax.tablet} {
    height: 100%;
    margin-bottom: 0;
  }

  @media only screen and ${deviceMax.mobileL} {
    height: 400px;
    margin-top: unset;
    margin-bottom: unset;
    padding: 10px;
  } ;
`;

export const QuestionContainer = styled.div`
  ${FLEX_CONTAINER.FlexColumn};
  width: 100%;
  height: 400px;
  background: ${COLORS.lightGray};
  border-radius: 16px;

  @media only screen and ${deviceMax.mobileL} {
    height: 100%;
  } ;
`;

export const FullScrollField = styled.div`
  width: 100%;
  height: 500px;

  @media only screen and ${deviceMax.tablet} {
    height: 300px;
  }

  @media only screen and ${deviceMax.mobileL} {
    height: 500px;
  }
`;

export const SelectedQuestionInfo = styled.div`
  ${FLEX_CONTAINER.FlexSpaceBetweenRow};
  padding-right: 20px;
  padding-left: 20px;
  margin-bottom: 10px;
  margin-top: 20px;
  height: 100px;
  width: 100%;

  @media only screen and ${deviceMax.tablet} {
    ${FLEX_CONTAINER.FlexSpaceBetweenColumn};
  }
`;

export const RequestStatus = styled.button`
  width: 134px;
  height: 30px;
  background: ${COLORS.blue};
  border-radius: 8px;
  color: ${COLORS.white};
  cursor: unset;

  &.green-background {
    background: ${COLORS.green};
    color: ${COLORS.white};
  }

  @media only screen and ${deviceMax.mobileL} {
    width: 96px;
    height: 30px;
  }
`;

export const StatusAndDate = styled.div`
  ${FLEX_CONTAINER.FlexSpaceBetweenRow};

  @media only screen and ${deviceMax.tablet} {
    flex-wrap: wrap;
    gap: 6px;
    ${FLEX_CONTAINER.FlexCenterRow};
  }
`;

export const QuestionsWrapper = styled.div`
  width: 100%;
  background: ${COLORS.lightGray};
  border-radius: 16px;
  padding: 20px;
`;

export const EachQuestionContainer = styled.div`
  ${FLEX_CONTAINER.FlexColumn};
  align-items: unset;
  width: 100%;
  padding: 10px 0;
  border-bottom: 1px solid ${COLORS.darkGray};
`;

export const QuestionText = styled.span`
  ${FONT_FAMILY.FontMedium}
  ${FONTS.font16}
  color: ${COLORS.black};

  @media only screen and ${deviceMax.tablet} {
    ${FONTS.font12};
  }
`;

export const AnswerText = styled.span`
  ${FONT_FAMILY.FontRegular}
  ${FONTS.font16}
  color: ${COLORS.black};

  @media only screen and ${deviceMax.tablet} {
    ${FONTS.font12};
  }
`;

export const RequestName = styled.div`
  ${FONT_FAMILY.FontMedium};
  ${FONTS.font20};
  text-align: ${({ questionList }) => (questionList ? 'left' : 'center')};
  color: ${COLORS.mainColor};
`;

export const RequestSubmitDate = styled.span`
  ${FONT_FAMILY.FontMedium};
  ${FONTS.font16};
  width: 100%;
  color: ${COLORS.mainColor};
  text-align: center;
`;

export const RequestsWrapper = styled.div`
  ${FLEX_CONTAINER.FlexSpaceBetweenRow};
  flex-wrap: wrap;
  width: 100%;
  padding: 10px 40px;

  @media only screen and ${deviceMax.laptopLMax} {
    ${FLEX_CONTAINER.FlexCenterRow};
  }

  @media only screen and ${deviceMax.tablet} {
    ${FLEX_CONTAINER.FlexCenterColumn};
    padding: 10px 22px;
  }

  @media only screen and ${deviceMax.mobileL} {
    padding-right: 10px;
    padding-left: 10px;
  }
`;
